import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = [ "editor", 'spinner' ]

    static values = {
        css: String,
        src: { type: String, default: "https://cdn.tiny.cloud/1/6hnf8ts612jw9bybqw2jgmckbbvn1n4blasxxdap33r043ud/tinymce/7/tinymce.min.js" }
    }

    async connect() {
        await this.loadTinyMCE()
        this.initEditor()
    }

    async loadTinyMCE() {
        if (window.tinymce) return

        return new Promise((resolve, reject) => {
            const script = document.createElement("script")
            script.src = this.srcValue
            script.referrerPolicy = "origin"
            script.onload = resolve
            script.onerror = reject
            document.head.appendChild(script)
        })
    }

    initEditor() {
        if (!this.editorTarget) return
        this.spinnerTarget.classList.add('hidden')

        tinymce.init({
            target: this.editorTarget,
            content_css: this.cssValue,
            height: 500,
            menubar: false,
            plugins: [
                'advlist', 'lists', 'preview',
                'searchreplace', 'visualblocks', 'code', 'fullscreen',
                'insertdatetime'
            ],
            toolbar: 'undo redo | bold italic underline strikethrough | forecolor backcolor | fontfamily fontsize blocks | alignleft aligncenter alignright alignjustify | outdent indent | numlist bullist | removeformat | fullscreen preview code'
        })
    }

    disconnect() {
        const textarea = this.editorTarget
        if (textarea?.id && tinymce.get(textarea.id)) {
            tinymce.get(textarea.id).remove()
        }
    }
}